// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const strs = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_STR':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_STR':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_STR':
      return { ...state }
    case 'EDIT_STR':
      return { ...state }
    case 'DELETE_STR':
      return { ...state }
    default:
      return { ...state }
  }
}
export default strs
